<template>
    <ol-style :overrideStyleFunction="overrideStyleFunction">
    </ol-style>
</template>



<script setup>

import { ref, computed, onMounted } from 'vue'
import * as olExtent from 'ol/extent';

import { Circle, Fill, Stroke, Style, RegularShape } from 'ol/style.js';
import { LineString, Point } from 'ol/geom.js';
import { Text } from 'ol/style.js';

import { useDataStore } from "@/store/data";

import { useRuntimeStore } from '@/store/runtime';

const dataStore = useDataStore();
const runtimeStore = useRuntimeStore();




const glyphPointMainCircle = "󰝥"
const glyphPointMainCircleSelected = "󰝦"

const glyphPointMainMarker = "󰍎"
const glyphPointMainMarkerSelected = "󰍎"



const errorsStates = [409, 422, 500]
const regularFontSize = 40
const todayFontSize = 72

const zIndex = ref(1)


onMounted(() => {


})



// colors

const coolBlue = "#00aaff"
const black = "#000000"
const white = "#ffffff"
const darkGrey = "#666666"
const lightGrey = "#aaaaaa"
const shadowColor = "#00000088"
const greenyellow = "#adff2f"


/* eslint-disable no-unused-vars */
const overrideStyleFunction = (feature, style, resolution) => {

    const model = feature.get('model');
    const label = feature.get('label');
    const uuid = feature.get('uuid');
    const state = feature.get('state')

    const data = dataStore.getDataFromFeatureUUID(uuid)

    // console.log(data)

    const geometry = feature.getGeometry();
    const gExt = geometry.getExtent()

    // // 5798522 is maximum y coordinate (much over vda)

    // // miny of 
    // // Extent{Array.<number>}
    // // An array of numbers representing an extent: [minx, miny, maxx, maxy].
    const miny = gExt[1]
    // // console.log(`label, y: ${label}, ${miny}`)
    // // main_style.setZIndex(miny)

    zIndex.value = 5798522 - parseInt(miny)




    // console.log(layer.value.name)
    const new_styles = []



    if (geometry.getType() === "Polygon" || geometry.getType() === "LineString") {

        const main_style = new Style({})

        let fillOpacyty = "88"
        let strokeOpacyty = "ff"

        main_style.setStroke(new Stroke({
            color: white + strokeOpacyty,
            width: 5,
            lineDash: [5, 10        ]

        }))





        const shadow_style =
            new Style({
                stroke: new Stroke({
                    color: black + "66",
                    width: 15,
                }),
                fill: new Fill({
                    color: coolBlue + "99",
                })

            })

        new_styles.push(shadow_style)
        new_styles.push(main_style)


    }



    if (geometry.getType() === "Point") {

        const main_style = new Style({
            image: new Circle({
                stroke: new Stroke({
                    color: white + "ff",
                    width: 5,
                    lineDash: [5, 10]
                }),
                radius: 30,
            })
        })



        const shadow_style =
            new Style({
                image: new Circle({
                    fill: new Fill({
                        color: "#0006",
                    }),
                    radius: 46,
                })

            })

        new_styles.push(shadow_style)
        new_styles.push(main_style)

    }



    new_styles.forEach((s) => s.setZIndex(zIndex.value))


    return new_styles

};




</script>
